const getDashboardList = ({ token }, { observer, biRepo }) => {
  biRepo.getDashboardList(
    { token },
    {
      success: (response) => {
        if (response.getDashboardList.error) {
          observer.errorWhileGettingDashboardList()
          return
        }
        observer.receiveDashboardList(response.getDashboardList.data)
      },
      failure: (e) => {
        observer.errorWhileGettingDashboardList()
      }
    }
  )
}

export default getDashboardList
